<template>
	<div class="col-lg-8 contentCol">
		<h1>Passwort vergessen</h1>
		<div style="padding-bottom:20px" id="requestPasswordText">
			Bitte gib deine E-Mail ein.<br>Du wirst eine E-Mail mit einem Link erhalten, über den du ein neues Passwort vergeben kannst.
		</div>
		<div style="padding-bottom:20px;display:none" id="mailSendText">
			Du wirst eine E-Mail mit einem Link erhalten, über den du ein neues Passwort vergeben kannst.
		</div>
		<form v-on:submit.prevent id="theForm">
			<div style="margin:10px 0 20px 0;max-width:320px">
				<div style="font-weight:700;">E-Mail-Adresse</div>
				<input type="text" v-model="email" id="email" />
				<friendly-captcha :sitekey="recaptchaSiteKey" v-on:done="frcDone" v-on:error="frcError"></friendly-captcha>
				<div id="errorbox" class="errorBox" style="display:none">
					Please solve the captcha first
				</div>
				<div style="margin-top:20px">
					<button v-on:click="requestPassword" class="btn btn-white teaserButton width100">Absenden</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import FriendlyCaptcha from './FriendlyCaptcha.vue';
export default {
	name: 'requestPassword',
	props: {
		'recaptchaSiteKey': {
			type: String,
			required: false,
			default: null
		}
	},
	data: function() {
		return {
			email: '',
			frcSolution: null
		}
	},
	methods: {
		requestPassword() {
			jQuery('#errorbox').empty();
			let hasErrors = false;
			if (!this.frcSolution) {
				jQuery('#errorbox').append('<p>Bitte löse das Captcha</p>');
				hasErrors = true;
			}
			if (!this.email) {
				jQuery('#errorbox').append('<p>Bitte gib eine E-Mail Adresse ein</p>');
				hasErrors = true;
			}
			if (hasErrors) {
				jQuery('#errorbox').show();
				return;
			}

			jQuery.ajax({
				url: '/requestNewPassword.json',
				type: 'POST',
				dataType: "json",
				data: JSON.stringify({
					email: this.email,
					captcha: this.frcSolution,
					test: 'debug'
				}),
				contentType: "application/json; charset=utf-8",
				success: function(data) {
					jQuery('#theForm').hide();
					jQuery('#requestPasswordText').hide();
					jQuery('#mailSendText').show();
				},
				error: function(error) {
					jQuery('#errorbox').empty();
					let errorCodes = error.responseJSON.whathappend;
					for (let i = 0; i < errorCodes.length; i++) {
						jQuery('#errorbox').append('<p>' + errorCodes[i][0] + '</p>');
					}
					jQuery("#errorbox").show();
				}
			})
		},
		frcDone: function(solution) {
			this.frcSolution =  solution;
		},
		frcError: function(error) {
			this.frcSolution = null;
			console.log("captcha error: " + error);
		}
	},
	components: { FriendlyCaptcha }
}
</script>



// WEBPACK FOOTER //
// RequestPassword.vue?c3c3f218